import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React from "react";
import type { Appearance } from "../data";
import {
  MicrosoftPromptsLabel,
  SuggestedPromptsLabel,
} from "./PromptTab.strings";
import { useStyles } from "./Tab.styles";

type SuggestedTabProps = {
  isSelected: boolean;
  appearance: Appearance;
  showV2Tabs: boolean;
};

export const SuggestedTab: React.FC<SuggestedTabProps> = ({
  isSelected,
  appearance,
  showV2Tabs,
}) => {
  const localizations = useStrings({
    MicrosoftPromptsLabel,
    SuggestedPromptsLabel,
  });

  const classes = useStyles(appearance)();
  return (
    <Tab
      aria-label={
        showV2Tabs
          ? localizations.MicrosoftPromptsLabel()
          : localizations.SuggestedPromptsLabel()
      }
      value={"AllPrompts"}
      data-testid="suggested-prompts-tab"
      className={isSelected ? classes.selected : classes.tab}
    >
      <Text className={isSelected ? classes.selectedText : classes.text}>
        {showV2Tabs
          ? localizations.MicrosoftPromptsLabel()
          : localizations.SuggestedPromptsLabel()}
      </Text>
    </Tab>
  );
};
